module.exports = __webpack_public_path__ + "cn.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/cn.svg
// module id = 752
// module chunks = 0